import React, { useState } from 'react'

import { Button, ModalBox } from '@fourthwall/components'

import * as S from './ChangeProductionMethodModal.styled'

type ChangeOption = {
  id: string
  productId: string
  productionMethod: {
    label: string
    title: string
    tooltip?: string
    advantages?: Array<string>
  }
}

type ChangeProductionMethodModalProps = {
  initialOption: ChangeOption
  options: Array<ChangeOption>
  onConfirm?: (option: ChangeOption) => void
  onClose?: () => void
}

export const ChangeProductionMethodModal = ({
  initialOption,
  options,
  onConfirm,
  onClose,
}: ChangeProductionMethodModalProps) => {
  const [selectedOption, setSelectedOption] = useState<ChangeOption>(initialOption)

  const handleConfirm = () => {
    if (selectedOption.id !== initialOption.id) {
      onConfirm?.(selectedOption)
    }
    onClose?.()
  }

  return (
    <ModalBox
      size="large"
      title="Choose on demand print method"
      onClose={onClose}
      buttons={[
        <Button label="Cancel" appearance="secondary" onClick={onClose} />,
        <Button label="Confirm" appearance="primary" onClick={handleConfirm} />,
      ]}
    >
      <S.Lead>
        This action will result in creating a duplicate of your product with a selected production
        method.
      </S.Lead>
      <S.Container>
        {options.map((option) => (
          <S.Column
            key={option.id}
            $active={selectedOption.id === option.id}
            onClick={() => {
              setSelectedOption(option)
            }}
          >
            <S.Heading>{option.productionMethod.label}</S.Heading>
            <S.Content>
              {option.productionMethod.advantages && (
                <ul>
                  {option.productionMethod.advantages.map((advantage) => (
                    <li key={advantage}>{advantage}</li>
                  ))}
                </ul>
              )}
            </S.Content>
          </S.Column>
        ))}
      </S.Container>
    </ModalBox>
  )
}
